module.exports = __webpack_public_path__ + "static/case-study-layer-right-d33ed002ee30bdaf5883c88467683e4c.png";